import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("seva_cart") || "[]");
        } catch {
            return [];
        }
    });
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem("seva_cart", JSON.stringify(items));
    }, [items]);

    const addItem = useCallback((product, size) => {
        const key = `${product.id}_${size}`;
        setItems((prev) => {
            const existing = prev.find((i) => i.key === key);
            if (existing) {
                return prev.map((i) =>
                    i.key === key ? { ...i, quantity: Math.min(i.quantity + 1, 10) } : i
                );
            }
            return [
                ...prev,
                {
                    key,
                    id: product.id,
                    name: product.name,
                    price: product.price,
                    image: product.image,
                    size,
                    quantity: 1,
                },
            ];
        });
        setIsOpen(true);
    }, []);

    const removeItem = useCallback((key) => {
        setItems((prev) => prev.filter((i) => i.key !== key));
    }, []);

    const updateQuantity = useCallback((key, delta) => {
        setItems((prev) =>
            prev
                .map((i) =>
                    i.key === key ? { ...i, quantity: Math.max(0, Math.min(10, i.quantity + delta)) } : i
                )
                .filter((i) => i.quantity > 0)
        );
    }, []);

    const clearCart = useCallback(() => setItems([]), []);

    const count = items.reduce((sum, i) => sum + i.quantity, 0);
    const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);

    return (
        <CartContext.Provider
            value={{
                items,
                isOpen,
                setIsOpen,
                addItem,
                removeItem,
                updateQuantity,
                clearCart,
                count,
                subtotal,
            }}
        >
            {children}
        </CartContext.Provider>
    );
};
